import React, { useEffect, useState } from 'react'
import map from 'lodash/map'
import ScrollingLoader from '@SiteComponents/ScrollingLoader'
import AssetRow from './AssetRow'

import {
  IElement,
  IDeleteElementPayload,
} from '@SiteModules/Element/types'

const COLUMN_COUNT = 6

import './AssetsTableList.scss'

interface AssetsTableListProps {
  readonly elements: IElement[]
  readonly loading: boolean
  readonly hasLoadedAllAssets: boolean
  handleDeleteElement(payload: IDeleteElementPayload): void
}

const LOADING_INDICATOR_DELAY = 180

const AssetsTableList: React.FC<AssetsTableListProps> = props => {
  const {
    elements,
    loading,
    hasLoadedAllAssets,
  } = props

  const [showLoadingIndicator, setShowLoadingIndicator] = useState(false)

  useEffect(() => {
    if (!loading) {
      setShowLoadingIndicator(false)
      return
    }

    const timeoutId = window.setTimeout(() => {
      setShowLoadingIndicator(true)
    }, LOADING_INDICATOR_DELAY)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [loading])

  const showFooter = !loading && hasLoadedAllAssets

  const renderTableHeader = () => {
    return (
      <tr>
        <th className="AssetsTableList__thumbnail-name">
          Name
        </th>
        <th className="AssetsTableList__size">
          Size
        </th>
        <th className="AssetsTableList__imported">
          Imported
        </th>
        <th className="AssetsTableList__edited">
          Edited
        </th>
        <th className="AssetsTableList__use-in-projects">
          Use in projects
        </th>
        <th className="AssetsTableList__more"/>
      </tr>
    )
  }

  const tableRows = map(elements, (element, index) => {
    return (
      <AssetRow
        key={index}
        index={index}
        element={element}
        handleDeleteElement={props.handleDeleteElement}
      />
    )
  })

  const renderLoader = () => {
    return (
      <tr>
        <td colSpan={COLUMN_COUNT}>
          <ScrollingLoader scale={0.5}/>
        </td>
      </tr>
    )
  }

  const renderFooter = () => {
    return (
      <React.Fragment>
        <tr className="AssetsTableList__line-container">
          <td colSpan={COLUMN_COUNT} className="AssetsTableList__line"/>
        </tr>
        <tr>
          <td colSpan={COLUMN_COUNT} className="AssetsTableList__footer">
            You've reached the end of the list.
          </td>
        </tr>
      </React.Fragment>
    )
  }

  return (
    <div className="AssetsTableList">
      <table>
        <thead>
          {renderTableHeader()}
        </thead>
        <tbody className="AssetsTableList__body">
          {tableRows}
          {showLoadingIndicator && renderLoader()}
          {showFooter && renderFooter()}
        </tbody>
      </table>
    </div>
  )
}

export default AssetsTableList
